module.exports = __webpack_public_path__ + "static/media/longest-drive.77de562b.png";